import AccountsPage from '@/modules/accounts/accounts-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/accounts/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AccountsPage />;
}
